/**
 * トップ INTRO セクションの吹き出しアニメーション
 * - 画面内に入ったときにふわっとフェードイン
 * - スクロールに応じたパララックスで浮遊感を演出
 */
export const topIntroPop = () => {
  const pops = document.querySelectorAll(".js-gsap-top-intro-pop");
  if (
    !pops.length ||
    typeof gsap === "undefined" ||
    typeof ScrollTrigger === "undefined"
  )
    return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector(".p-top-intro");
  if (!section) return;

  // 要素ごとにずらすパララックス速度（大きいほど動く）
  const parallaxSpeeds = [80, -75, 60, -60];

  pops.forEach((pop, i) => {
    // フェードインアニメーション（各要素を時差で表示）
    gsap.set(pop, { opacity: 0, y: 50 });

    gsap.to(pop, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.out",
      delay: i * 0.2,
      scrollTrigger: {
        trigger: section,
        start: "top 70%",
        once: true,
      },
    });

    // パララックス（スクロール連動で上下に動く）
    gsap.to(pop, {
      y: parallaxSpeeds[i] ?? 40,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5,
      },
    });
  });
};
